import { USERNAME } from "@/mk2/helpers/urls";

export const wallUrl = "/wall/";
export const wallMentionsUrl = `/wall/${USERNAME}/`;
